var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCursor28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0811 4.62709C19.0811 3.98974 18.5937 3.50235 17.9564 3.50235H17.4315C16.2693 3.46486 15.107 3.87726 14.2072 4.62709C13.3074 3.87726 12.1827 3.46486 10.983 3.50235H10.4581C9.82076 3.50235 9.33337 3.98974 9.33337 4.62709C9.33337 5.26444 9.82076 5.75183 10.4581 5.75183H10.983C12.1827 5.75183 13.0825 6.38918 13.0825 6.98903V9.12603H11.9578C11.3204 9.12603 10.833 9.61342 10.833 10.2508C10.833 10.8881 11.3204 11.3755 11.9578 11.3755H13.0825V21.011C13.0825 21.5733 12.1827 22.2482 10.983 22.2482H10.4581C9.82076 22.2482 9.33337 22.7356 9.33337 23.3729C9.33337 24.0103 9.82076 24.4976 10.4581 24.4976H10.983C12.1452 24.5351 13.3074 24.1227 14.2072 23.3729C15.107 24.1227 16.2318 24.5351 17.4315 24.4976H17.9564C18.5937 24.4976 19.0811 24.0103 19.0811 23.3729C19.0811 22.7356 18.5937 22.2482 17.9564 22.2482H17.4315C16.2318 22.2482 15.332 21.6108 15.332 21.011V11.3755H16.4567C17.0941 11.3755 17.5814 10.8881 17.5814 10.2508C17.5814 9.61342 17.0941 9.12603 16.4567 9.12603H15.332V6.95154C15.332 6.38918 16.2318 5.71433 17.4315 5.71433H17.9564C18.5937 5.75183 19.0811 5.26444 19.0811 4.62709Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCursor28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;